<template lang="pug">
v-touch(v-on:tap="viewPost()")
  .post-tile(:class="[size,{ 'hover': hover }]" @mouseenter="hoverTile" @mouseleave="unhoverTile")
    .media(:style="{ backgroundImage: `url(${cdnURL}/members/uploads/medium/${item.data})` }")
    .likes(v-if="item.like_count > 0") #[span {{ item.like_count }}] #[icon(icon="heart" size="xs")]
</template>

<script>
export default {
  name: "PostTile",
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: "small"
    }
  },
  data() {
    return {
      cdnURL: process.env.VUE_APP_CDN_URL,
      hover: false
    };
  },
  methods: {
    unhoverTile() {
      this.hover = false;
    },
    hoverTile() {
      this.hover = true;
      setTimeout(() => {
        this.hover = false;
      }, 1500);
    },
    viewPost() {
      this.$router.push({ name: "post", params: { id: this.item.id } });
    }
  }
};
</script>

<style lang="stylus">
.post-tile {
  animate();
  box-sizing: border-box;
  border: white 2px solid;
  float: left;
  overflow: hidden;
  position: relative;

  &.small {
    width: calc((100% / 5));

    .media {
      padding-bottom: 100%;
      width: 100%;
    }
  }

  &.large {
    width: calc((100% / 3));

    .media {
      padding-bottom: 100%;
      width: 100%;
    }
  }

  .likes {
    animate();
    border-radius(15px);
    background-color: alpha(black, 0.2);
    color: white;
    line-height: 30px;
    font-size: 1em;
    font-weight: bold;
    left: 50%;
    top: 50%;
    position: absolute;
    pointer-events: none;
    transform: translate(-50%, -50%) scale(0.5);
    opacity: 0;
    padding: 0 15px;
    white-space: nowrap;
  }

  &.hover {
    opacity: 0.9;
    cursor: pointer;
    // transform: scale(0.95);
    z-index: 1;

    .likes {
      background-color: alpha(black, 0.8);
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .media {
    background-image();
    background-size: cover;
    background-color: white;
    pointer-events: none;
  }
}
</style>
